module.exports = __webpack_public_path__ + "img/touchpanel.b6881657.jpg";